import {Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {ReportWithdrawalGrid} from "./admin_grid";
import {ReportWithdrawalForm} from "./admin_form";
import {getWithdrawalReport} from "../../../services/report/withdrawal";
import {CardFooterPaginator} from "../../system/cardFooterPaginator";
import SelectInput from "../../system/select";
import {getPersonsNameAndFamily, getPersonsPhone} from "../../../services/profile/profile";
import Dict from "../../../helper/dict";
import FromToNumberField from "../../system/fromToNumberField";
import FromToDateField from "../../system/fromToDateField";
import {downloadFile} from "../../../config";


export function ReportWithdrawalManagement() {

  const [withdrawals, setWithdrawals] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(5);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  const [personId, setPersonId] = useState(null);
  const [minValue, setMinValue] = useState(null);
  const [maxValue, setMaxValue] = useState(null);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getWithdrawalReport(paginate);
    if (result.status === 200) {
      const {withdrawalList, total_count} = result.data;
      setWithdrawals(withdrawalList || []);
      setGridTotalRowCount(total_count);
    }
  }

  const filter = () => {
    const filterParams = {}

    if (personId) {
      filterParams.append("person_id", personId)
    }

    if (minValue) {
      filterParams.append("min_value", minValue)
    }

    if (maxValue) {
      filterParams.append("max_value", minValue)
    }

    if (dateFrom) {
      filterParams.append("date_from", dateFrom)
    }

    if (dateTo) {
      filterParams.append("date_to", dateTo)
    }

    return filterParams
  }

  useEffect(() => {
    // const data = filter()
    const paginateParams = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    })

    const params = filter();
    const filterParams = new URLSearchParams(params);


    for (const [key, value] of filterParams.entries()) {
      paginateParams.append(key, value);
    }

    const paginate = paginateParams.toString()
    getData(paginate)
  }, [personId, minValue, maxValue, dateFrom, dateTo, gridCurrentPage, gridRowCount, sortBy, sortType, lastDataRefresh]);


  return (
    <div className="">
      {modalOpen && <ReportWithdrawalForm withdrawal={gridSelectedRow} open={modalOpen} setOpen={setModalOpen}
                                          setLastDataRefresh={setLastDataRefresh}
                                          setGridSelectedRow={setGridSelectedRow}/>}
      <Card className="pt-8">
        <CardHeader floated={true} shadow={false} className="rounded-none">
          <div className="mb-8 flex items-center justify-between gap-8">
            <Typography variant="h5" color="blue-gray">درخواست‌های برداشت</Typography>
          </div>
        </CardHeader>
        <CardBody className="overflow-x-auto w-full">
          <div className="grid grid-cols-1 gap-2 mb-2 md:grid-cols-3 xxl:grid-cols-3">

            <div className="flex flex-col">
              <SelectInput
                label={"نام"}
                defaultValue={personId}
                refreshSignal={personId}
                // multiselect={false}
                autoLoadService={getPersonsNameAndFamily}
                autoLoadRender={({name, family}) => {
                  return name + " " + family
                }}
                onChange={setPersonId}
              />
            </div>

            <div className="flex flex-col">
              <SelectInput
                label={Dict("phone")}
                defaultValue={personId}
                refreshSignal={personId}
                autoLoadService={getPersonsPhone}
                autoLoadRender={({phone}) => {
                  return phone
                }}
                onChange={setPersonId}
              />
            </div>

          </div>

          <div className="grid grid-cols-1 gap-1 mb-2 md:grid-cols-2 xxl:grid-cols-2">
            <FromToNumberField
              label="مبلغ"
              fromNumber={minValue}
              setFromNumber={setMinValue}
              toNumber={maxValue}
              setToNumber={setMaxValue}
            />

            <FromToDateField
              label="تاریخ"
              fromDate={dateFrom}
              setFromDate={setDateFrom}
              toDate={dateTo}
              setToDate={setDateTo}
            />

          </div>

          <div className="flex flex-row justify-between">
            <Button variant="gradient" color="gray" onClick={() => {
              setPersonId(null)
              setMinValue(null);
              setMaxValue(null);
              setDateFrom("");
              setDateTo("");
            }} className="ml-1">
              <span>حذف فیلتر</span>
            </Button>

            {withdrawals.length > 0 &&
              <Button size="sm" variant="outlined" onClick={() => {
                const data = filter();
                downloadFile("withdrawal_report_excel", data, "all withdrawals")
              }}>
                خروجی اکسل
              </Button>
            }
          </div>

          <ReportWithdrawalGrid withdrawals={withdrawals}
                                setModalOpen={setModalOpen}
                                setSelectedRow={setGridSelectedRow}
                                setSortBy={setSortBy}
                                sortType={sortType}
                                setSortType={setSortType}
          />
        </CardBody>

        <CardFooterPaginator
          active={gridCurrentPage}
          setActive={setGridCurrentPage}
          totalRows={gridTotalRowCount}
          rowsCount={gridRowCount}
          setRowsCount={setGridRowCount}
          from={from}
          to={to}
        />
      </Card>
    </div>
  );
}